import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Basis Klasse für Components die Subscriptions managen müssen
 *
 * z.B. Idiomatische Vorgehensweise am Beispiel einer FormControl valueChange Subscription:
 * <code>
 *  this.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => console.log(value));
 * </code>
 *
 * Subscriptions die entstehen (hier bei "valueChanges") müssen wieder "aufgeräumt" werden da ansonsten ein
 * "Memory Leak" entsteht.
 *
 */
/**
 * Base Component which manages redux store with implementing lifecycle methods
 * @deprecated use import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
 */
@Directive()
export class MngBaseSubscriptionComponent implements OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnDestroy(): void {
    // console.log('ngOnDestroy on MngBaseSubscriptionComponent');
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
